import { combineReducers, createStore as reduxCreateStore } from "redux"
import { contactFormReducer } from "./contactFormState/contactFormState"
import couterReducer from "./counterState/couterState"



const createStore = () => reduxCreateStore(combineReducers({ counter: couterReducer, contactForm: contactFormReducer }))
export default createStore